import React, { useState, useEffect, useCallback } from 'react';
import withRoleAccess from '../../hoc/withRoleAccess';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { CSVLink } from 'react-csv';
import { jwtDecode } from "jwt-decode";
import { 
  Card, 
  Form, 
  Input, 
  Select, 
  Button, 
  Row, 
  Col, 
  InputNumber, 
  Checkbox,
  message,
  Space,
  Typography,
  Table,
  Drawer,
  Modal,
  Divider,
  Popconfirm, 
  DatePicker,
  Tabs,
  Tag
} from 'antd';
import { 
  FileTextOutlined, 
  EyeOutlined, 
  PlusOutlined, 
  DeleteOutlined, 
  EditOutlined,
  DownloadOutlined,
  BankOutlined,
  SearchOutlined,
  UserOutlined,
  FilterOutlined
} from '@ant-design/icons';
import axios from 'axios';
import moment from 'moment';
import QuotationPreview from './QuotationPreview';
import dayjs from "dayjs";

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const CreateQuotation = () => {
  const [form] = Form.useForm();
  const [tempStudentForm] = Form.useForm();
  const [bankDetailsForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [students, setStudents] = useState([]);
  const [classes, setClasses] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState([
  dayjs().startOf("month"), // e.g. 01 Aug 2025
  dayjs().endOf("month")    // e.g. 31 Aug 2025
])
  const [quotations, setQuotations] = useState([]);
  const [quotationItems, setQuotationItems] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewData, setPreviewData] = useState(null);

  // Modal and Drawer states
  const [quotationDrawerVisible, setQuotationDrawerVisible] = useState(false);
  const [tempStudentModalVisible, setTempStudentModalVisible] = useState(false);
  const [bankDetailsModalVisible, setBankDetailsModalVisible] = useState(false);
  const [editingQuotation, setEditingQuotation] = useState(null);
  const [editingTempStudent, setEditingTempStudent] = useState(null);
  const [editingBankDetails, setEditingBankDetails] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  // Form states
  const [studentType, setStudentType] = useState('existing');
  const [tempStudents, setTempStudents] = useState([]);
  const [studentDetails, setStudentDetails] = useState({});
  const [selectedBankDetails, setSelectedBankDetails] = useState({});
  const [promotion, setPromotion] = useState(0);
  const [vat, setVat] = useState(true);
  const [activeTab, setActiveTab] = useState('quotation');
  const [previewExpirationDays, setPreviewExpirationDays] = useState(3);
  const [customCreatedAt, setCustomCreatedAt] = useState(null);
  
   const token = localStorage.getItem("token");
        let userRole = null;
        let userBranchId = null;
    
        if (token) {
        try {
            const decoded = jwtDecode(token);
            userRole = decoded.role;
            // Support both formats just in case
            userBranchId = decoded.branchId || decoded.branch_id || null;
        } catch (err) {
            console.error("Invalid token", err);
        }
        }
 const API_URL = process.env.REACT_APP_API_URL;

   useEffect(() => {
  const fetchBranches = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API_URL}/branch`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setBranches(res.data);
    } catch (err) {
      console.error("Failed to fetch branches", err);
    }
  };

  fetchBranches();
}, [API_URL]);

  // Fetch functions
const fetchStudents = useCallback(async (search = '') => {
  try {
    setIsLoading(true);
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    const params = { search };

    if (role === "admin" && branchId) {
      params.branchId = branchId;
    }
    if (role === "superadmin" && selectedBranch) {
      params.branchFilter = selectedBranch;
    }

    const response = await axios.get(`${API_URL}/students/reg-students-select`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    if (response.data.success) {
      setStudents(response.data.students);
    } else {
      console.warn('⚠️ Unexpected response format:', response.data);
    }
  } catch (error) {
    console.error('❌ Error fetching students:', error);
    message.error('Failed to fetch students');
  } finally {
    setIsLoading(false);
  }
}, [API_URL, selectedBranch]);



const fetchClasses = useCallback(async () => {
  try {
    setIsLoading(true);
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    const params = {};
    if (role === "admin" && branchId) {
      params.branchId = branchId;
    }
    if (role === "superadmin" && selectedBranch) {
      params.branchFilter = selectedBranch;
    }

    const response = await axios.get(`${API_URL}/class-groups`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    const classesData = Array.isArray(response.data) ? response.data : [];
    const filteredClasses = classesData.filter((classGroup) => {
      const endDate = new Date(classGroup.end_date);
      const today = new Date();
      return endDate >= today;
    });

    setClasses(filteredClasses);
  } catch (error) {
    console.error('Error fetching classes:', error);
    message.error('Failed to fetch classes');
  } finally {
    setIsLoading(false);
  }
}, [API_URL, selectedBranch]);


const fetchTempStudents = useCallback(async () => {
  try {
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    const params = {};
    if (role === "admin" && branchId) {
      params.branchId = branchId;
    }
    if (role === "superadmin" && selectedBranch) {
      params.branchFilter = selectedBranch;
    }

    const response = await axios.get(`${API_URL}/quotations/temp-student`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    setTempStudents(response.data);
  } catch (error) {
    console.error('Error fetching temp students:', error);
    message.error('Failed to fetch temp students');
  }
}, [API_URL, selectedBranch]);


  const fetchBankDetails = useCallback(async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/bank-details`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setBankDetails(response.data);
  } catch (error) {
    console.error('[fetchBankDetails] Error fetching bank details:', error);
    message.error('Failed to fetch bank details');
  }
}, [API_URL]);

const fetchQuotations = useCallback(async () => {
  try {
    setIsLoading(true);
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    const params = {
      search: searchTerm,
      startDate: dateRange[0] ? dateRange[0].format('YYYY-MM-DD') : undefined,
      endDate: dateRange[1] ? dateRange[1].format('YYYY-MM-DD') : undefined,
    };

    if (role === "admin" && branchId) {
      params.branchId = branchId;
    }
    if (role === "superadmin" && selectedBranch) {
      params.branchFilter = selectedBranch;
    }

    const response = await axios.get(`${API_URL}/quotations`, {
      headers: { Authorization: `Bearer ${token}` },
      params
    });

    setQuotations(response.data);
  } catch (error) {
    console.error('[fetchQuotations] Error:', error);
    message.error('Failed to fetch quotations');
  } finally {
    setIsLoading(false);
  }
}, [API_URL, searchTerm, dateRange, selectedBranch]);


useEffect(() => {
  const branchId = userRole === "admin" ? userBranchId : selectedBranch;

  fetchStudents("", branchId);
  fetchTempStudents(branchId);
  fetchClasses(branchId);
  fetchQuotations(branchId);
  fetchBankDetails(branchId);
}, [
  userRole,
  userBranchId,
  selectedBranch,
  fetchStudents,
  fetchTempStudents,
  fetchClasses,
  fetchQuotations,
  fetchBankDetails,
]);


  const fetchQuotationById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${API_URL}/quotations/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    const quotation = response.data;

    // Set student type based on available ID
    if (quotation.student_id) {
      setStudentType('existing');
      handleStudentSelect(quotation.student_id);
    } else if (quotation.temp_student_id) {
      setStudentType('temp');
      handleTempStudentSelect(quotation.temp_student_id);
    }

    // Set form values
    form.setFieldsValue({
        studentId: quotation.student_id || null,
        tempStudentId: quotation.temp_student_id || null,
        bankDetailsId1: quotation.bank_details_id_1 || null,
        bankDetailsId2: quotation.bank_details_id_2 || null,
        remark: quotation.remark || '', // ✅ Fix for missing remark
        branch_id: quotation.branch_id || (userRole === "admin" ? userBranchId : selectedBranch), // 👈
});

        // ✅ This is key if you're using selectedBankDetails[1] and [2]
        handleBankDetailsSelect(quotation.bank_details_id_1, 1);
        handleBankDetailsSelect(quotation.bank_details_id_2, 2);

    setPromotion(quotation.discount || 0);
    setVat(quotation.vat > 0);
    setSelectedBranch(quotation.branch_id || selectedBranch || userBranchId);
    // Map items into your state
    const items = quotation.items.map((item, index) => ({
      id: Date.now() + index,
      description: item.description,
      price_per_unit: item.unit_price,
      quantity: item.quantity,
      total: item.amount,
      type: item.class_code ? 'class' : 'custom',
      class_code: item.class_code || null,
    }));

    setQuotationItems(items);
    setEditingQuotation(quotation);
    setQuotationDrawerVisible(true);
  } catch (error) {
    console.error('[fetchQuotationById] Error:', error);
    message.error('Failed to load quotation data');
  }
};

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
const handleDateRangeChange = (newRange) => {
  setDateRange(newRange);
};

useEffect(() => {
  if (quotationDrawerVisible) {
    if (userRole === "admin" && userBranchId) {
      form.setFieldsValue({ branch_id: userBranchId });
      setSelectedBranch(userBranchId); // keep state in sync
    } else if (userRole === "superadmin" && selectedBranch) {
      form.setFieldsValue({ branch_id: selectedBranch });
    }
  }
}, [quotationDrawerVisible, userRole, userBranchId, selectedBranch, form]);

  // Temp Student Functions
const handleCreateTempStudent = async (values) => {
  try {
    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    let payload = { ...values };

    if (role === "admin" && branchId) {
      payload.branch_id = branchId; // force admin branch
    }
    if (role === "superadmin" && selectedBranch) {
      payload.branch_id = selectedBranch; // superadmin chooses
    }

    if (editingTempStudent) {
      // Update existing
      await axios.put(`${API_URL}/quotations/temp-student/${editingTempStudent.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Temporary student updated successfully!');
    } else {
      // Create new
      await axios.post(`${API_URL}/quotations/temp-student`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Temporary student created successfully!');
    }

    setTempStudentModalVisible(false);
    tempStudentForm.resetFields();
    setEditingTempStudent(null);
    fetchTempStudents();
  } catch (error) {
    console.error('[handleCreateTempStudent] Error:', error);
    message.error('Failed to save temporary student');
  }
};


const handleEditTempStudent = (student) => {
  setEditingTempStudent(student);
  tempStudentForm.setFieldsValue({
    firstname: student.firstname,
    lastname: student.lastname,
    nickname: student.nickname,
    phone: student.phone,
    address: student.address,
    branch_id: student.branch_id || null // optional, only for superadmin
  });
  setTempStudentModalVisible(true);
};


  const handleDeleteTempStudent = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/quotations/temp-student/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Temporary student deleted successfully!');
      fetchTempStudents();
    } catch (error) {
      console.error('[handleDeleteTempStudent] Error:', error);
      message.error('Failed to delete temporary student');
    }
  };

  const handleBankDetailsSelect = (bankId) => {
    const selected = bankDetails.find(b => b.id === bankId);
    if (selected) {
      setSelectedBankDetails(selected);
      form.setFieldsValue({
        bankDetailsId: bankId,
        bankName: selected.bank_name,
        bankBranch: selected.bank_branch,
        accountName: selected.account_name,
        accountNumber: selected.account_number
      });
    }
  };

  // Bank Details Functions
  const handleCreateBankDetails = async (values) => {
    try {
      const token = localStorage.getItem('token');
      
      if (editingBankDetails) {
        // Update existing bank details
        await axios.put(`${API_URL}/bank-details/${editingBankDetails.id}`, values, {
          headers: { Authorization: `Bearer ${token}` }
        });
        message.success('Bank details updated successfully!');
      } else {
        // Create new bank details
        await axios.post(`${API_URL}/bank-details`, values, {
          headers: { Authorization: `Bearer ${token}` }
        });
        message.success('Bank details created successfully!');
      }

      setBankDetailsModalVisible(false);
      bankDetailsForm.resetFields();
      setEditingBankDetails(null);
      fetchBankDetails();
    } catch (error) {
      console.error('Error saving bank details:', error);
      message.error('Failed to save bank details');
    }
  };

  const handleEditBankDetails = (bankDetail) => {
    setEditingBankDetails(bankDetail);
    bankDetailsForm.setFieldsValue({
      bank_name: bankDetail.bank_name,
      bank_branch: bankDetail.bank_branch,
      account_name: bankDetail.account_name,
      account_number: bankDetail.account_number
    });
    setBankDetailsModalVisible(true);
  };

  const handleDeleteBankDetails = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`${API_URL}/bank-details/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Bank details deleted successfully!');
      fetchBankDetails();
    } catch (error) {
      console.error('[handleDeleteBankDetails] Error:', error);
      const backendMsg = error?.response?.data?.message || 'Failed to delete bank details';
      message.error(backendMsg);
    }
  };

  // Item Management Functions
  const addQuotationItem = () => {
    const newItem = {
      id: Date.now(),
      type: 'custom',
      description: '',
      price_per_unit: 0,
      quantity: 1,
      total: 0
    };
    setQuotationItems([...quotationItems, newItem]);
  };

  const addClassItem = (classData) => {
    const newItem = {
      id: Date.now(),
      type: 'class',
      class_code: classData.class_code,
      description: classData.title,
      price_per_unit: classData.price,
      quantity: 1,
      total: classData.price
    };
    setQuotationItems([...quotationItems, newItem]);
  };

const updateQuotationItem = (id, field, value) => {
  setQuotationItems(items =>
    items.map(item => {
      if (item.id === id) {
        const updatedItem = { ...item, [field]: value };

        // Ensure numeric
        const quantity = Number(updatedItem.quantity || 1);
        const unitPrice = Number(updatedItem.price_per_unit || 0);

        updatedItem.total = Number(updatedItem.quantity) * Number(updatedItem.price_per_unit);
        updatedItem.quantity = quantity;
        updatedItem.price_per_unit = unitPrice;

        return updatedItem;
      }
      return item;
    })
  );
};

  const removeQuotationItem = (id) => {
    setQuotationItems(items => items.filter(item => item.id !== id));
  };

  // Calculation Functions
 const calculateSubtotal = () => {
  return quotationItems.reduce((sum, item) => {
    const total = parseFloat(item.total || item.amount || 0);
    return sum + (isNaN(total) ? 0 : total);
  }, 0);
};


  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const discountAmount = parseFloat(promotion) || 0;
    const afterDiscount = subtotal - discountAmount;
    const vatAmount = vat ? afterDiscount * 0.07 : 0;
    return afterDiscount + vatAmount;
  };

  // Student Selection Functions
const handleStudentSelect = (studentId) => {
  const selected = students.find(s => s.value === studentId);
  if (!selected) return;

  const { label, contactInfo = {} } = selected;
  const [firstname = '', lastname = ''] = label.split(' ');

  const detail = {
    firstname,
    lastname,
    phone: contactInfo.phone || '',
    address: contactInfo.address || '',
  };

  setStudentDetails(detail);
  form.setFieldsValue(detail);
};


const handleTempStudentSelect = (tempId) => {
  const selected = tempStudents.find(s => s.id === tempId);
  if (!selected) return;

  const detail = {
    firstname: selected.firstname || '',
    lastname: selected.lastname || '',
    phone: selected.phone || '',
    address: selected.address || '',
  };

  setStudentDetails(detail);
  form.setFieldsValue(detail);
};

const generateQuotationNumber = () => {
  const branchId = userRole === 'admin'
    ? userBranchId
    : (selectedBranch || userBranchId || '1'); 

  return `QO-B${branchId}-${moment().format('YYMMDDHHmmss')}`;
};



const handleSubmitQuotation = async () => {
  try {
    await form.validateFields();

    if (quotationItems.length === 0) {
      message.error('Please add at least one item to the quotation');
      return;
    }

    const formValues = form.getFieldsValue();
    const subtotal = calculateSubtotal();
    const discountAmount = parseFloat(promotion) || 0;
    const afterDiscount = subtotal - discountAmount;
    const vatAmount = vat ? afterDiscount * 0.07 : 0;
    const total = afterDiscount + vatAmount;

    const token = localStorage.getItem('token');
    const decoded = jwtDecode(token);
    const role = decoded.role;
    const branchId = decoded.branchId || decoded.branch_id;

    // ✅ Build payload
    const payload = {
      quotation_no: editingQuotation
        ? editingQuotation.quotation_no
        : generateQuotationNumber(),
      student_id: studentType === 'existing' ? formValues.studentId : null,
      temp_student_id: studentType === 'temp' ? formValues.tempStudentId : null,
      bank_details_id_1: formValues.bankDetailsId1 || null,
      bank_details_id_2: formValues.bankDetailsId2 || null,
      remark: formValues.remark || '',
      items: quotationItems.map(item => ({
        description: item.type === 'class' ? item.class_code : item.description,
        quantity: Number(item.quantity) || 1,
        unit_price: Number(item.price_per_unit) || 0,
        amount: Number(item.total) || 0
      })),
      subtotal: Number(subtotal),
      discount: Number(discountAmount),
      vat: Number(vatAmount),
      total_amount: Number(total),
    };

    // ✅ Enforce branch assignment
    if (role === "admin" && branchId) {
      payload.branch_id = branchId;
    }
    if (role === "superadmin" && selectedBranch) {
      payload.branch_id = selectedBranch;
    }

    // ✅ Submit request
    if (editingQuotation) {
      await axios.put(`${API_URL}/quotations/${editingQuotation.id}`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Quotation updated successfully!');
    } else {
      await axios.post(`${API_URL}/quotations`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      message.success('Quotation created successfully!');
    }

    setQuotationDrawerVisible(false);
    resetForm();
    fetchQuotations();
  } catch (error) {
    console.error('[handleSubmitQuotation] Error:', error);
    message.error('Failed to submit quotation');
  }
};


const handleDeleteQuotation = async (id) => {
  try {
    const token = localStorage.getItem('token');
    await axios.delete(`${API_URL}/quotations/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    message.success('Quotation deleted');
    fetchQuotations();
  } catch (error) {
    console.error('[handleDeleteQuotation] Error:', error);
    message.error('Failed to delete quotation');
  }
};

const handlePreview = (quotation) => {
  const subtotal = (quotation.items || []).reduce((sum, item) => {
    const amount = parseFloat(item.amount) || 0;
    return sum + amount;
  }, 0);

  const discount = parseFloat(quotation.discount) || 0;
  const vat = parseFloat(quotation.vat) || 0;

  setPreviewData({
    ...quotation,
    subtotal,
    discount,
    vat,
    total_amount: parseFloat(quotation.total_amount) || 0,
    remark: quotation.remark || '',
    student_name: `${quotation.student_firstname || ''} ${quotation.student_lastname || ''}`.trim(),
    address: quotation.student_address || '-',
    phone: quotation.student_phone || '-',
    email: quotation.student_email || '-',
    expiration_date: quotation.created_at
      ? moment(quotation.created_at).add(quotation.expiration_days || 3, 'days').format('DD MMM YYYY')
      : null,
  });

  setPreviewVisible(true);
};


const formatDate = (date) =>
  date ? moment(date).format("DD-MMM-YY") : "";

const formatDateTime = (dateTime) =>
  dateTime ? moment(dateTime).format("DD-MMM-YY HH:mm") : "";

const ExportQuotationsCSV = ({ data }) => {
  const csvData = data.map((q) => ({
    "Quotation No": q.quotation_no,
    "Branch": q.branch_name || `Branch ${q.branch_id}`,
    "Student": q.student_name,
    "Created At": formatDate(q.created_at),
    "Discount": q.discount,
    "VAT": q.vat,
    "Total Amount": q.total_amount,
    "Remark": q.remark || "",
    "Bank 1": q.bank1_name || "",
    "Bank 2": q.bank2_name || "",
    "Item Description": (q.items || []).map((i) => i.description).join(", "),
    "Item Qty": (q.items || []).map((i) => i.quantity).join(", "),
    "Item Unit Price": (q.items || []).map((i) => i.unit_price).join(", "),
    "Item Amount": (q.items || []).map((i) => i.amount).join(", "),
  }));

  // Add the return statement and closing brace
  return csvData;
};

  const resetForm = () => {
    form.resetFields();
    setQuotationItems([]);
    setStudentDetails({});
    setSelectedBankDetails({});
    setPromotion(0);
    setVat(true);
    setStudentType('existing');
    setEditingQuotation(null);
    setActiveTab('quotation');
  };

  // Format number for display
  const formatNumber = (num) => {
    return new Intl.NumberFormat('th-TH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num || 0);
  };

      const branchColors = {
  1: "blue",
  2: "green",
  3: "magenta", 
};

  // Table columns for quotations list
  const quotationColumns = [

    {
    title: 'Branch',
    key: "branch",
    dataIndex: "branch_id",
    width: 120,
    ellipsis: true,
    render: (_, record) => {
      const branchId = record.branch_id;
      const color = branchColors[branchId] || "default";
      return record.branch_name ? (   // ✅ make sure your API returns branch_name
        <Tag color={color}>{record.branch_name}</Tag>
      ) : (
        <Tag>-</Tag>
      );
    },
  },
    {
      title: 'Quotation No',
      dataIndex: 'quotation_no',
      key: 'quotation_no',
    },
    {
      title: 'Date Created',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => moment(date).format('DD MMM YYYY'),
    },
    {
      title: 'Student',
      dataIndex: 'student_name',
      key: 'student_name',
    },
    {
      title: 'Total Amount',
      dataIndex: 'total_amount',
      key: 'total_amount',
      render: (amount) => `฿${formatNumber(amount)}`,
    },
    {
      title: 'Created By',
      dataIndex: 'created_by_nickname',
      key: 'created_by_nickname',
    },
    {
      title: 'Unique ID',
      dataIndex: 'uniqueid',
      key: 'uniqueid',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => fetchQuotationById(record.id)}
          />
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => handlePreview(record)}
          />
          <Popconfirm
            title="Are you sure to delete this quotation?"
            onConfirm={() => handleDeleteQuotation(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Table columns for quotation items
  const itemColumns = [
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      render: (text, record) => (
        record.type === 'class' ? (
          <Text type="secondary">{record.class_code}</Text>
        ) : (
          <Input
            value={text}
            onChange={(e) => updateQuotationItem(record.id, 'description', e.target.value)}
            placeholder="Enter description"
          />
        )
      ),
    },
    {
      title: 'Price/Unit',
      dataIndex: 'price_per_unit',
      key: 'price_per_unit',
      render: (value, record) => (
        <InputNumber
          value={value}
          onChange={(val) => updateQuotationItem(record.id, 'price_per_unit', val)}
          min={0}
          precision={2}
          style={{ width: '100%' }}
          formatter={value => `฿ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
          parser={value => value.replace(/฿\s?|(,*)/g, '')}
        />
      ),
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (value, record) => (
        <InputNumber
          value={value}
          onChange={(val) => updateQuotationItem(record.id, 'quantity', val)}
          min={1}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (value) => `฿${formatNumber(value)}`,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Popconfirm
          title="Are you sure you want to remove this item?"
          onConfirm={() => removeQuotationItem(record.id)}
        >
          <Button type="link" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ];

  // Temp Students table columns
  const tempStudentColumns = [
    {
      title: 'Name',
      key: 'name',
      render: (_, record) => `${record.firstname} ${record.lastname}`,
    },
    {
      title: 'Nickname',
      dataIndex: 'nickname',
      key: 'nickname',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      ellipsis: true,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditTempStudent(record)}
          />
          <Popconfirm
            title="Are you sure to delete this temporary student?"
            onConfirm={() => handleDeleteTempStudent(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Bank Details table columns
  const bankDetailsColumns = [
    {
      title: 'Bank Name',
      dataIndex: 'bank_name',
      key: 'bank_name',
    },
    {
      title: 'Branch',
      dataIndex: 'bank_branch',
      key: 'bank_branch',
      render: (text) => text || '-',
    },
    {
      title: 'Account Name',
      dataIndex: 'account_name',
      key: 'account_name',
    },
    {
      title: 'Account Number',
      dataIndex: 'account_number',
      key: 'account_number',
      render: (text) => `**** **** **** ${text.slice(-4)}`,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditBankDetails(record)}
          />
          <Popconfirm
            title="Are you sure to delete this bank details?"
            onConfirm={() => handleDeleteBankDetails(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ paddingTop: '80px', paddingLeft: '80px', maxWidth: '100%', margin: '0 auto' }}>
      <Sidebar />
      <Header />
      
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <Title level={2}>
          <FileTextOutlined /> Quotation Management
        </Title>
        <Space>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setQuotationDrawerVisible(true)}
          >
            Create New Quotation
          </Button>
            <CSVLink
  data={quotations.map((q) => ({
    "Quotation No": q.quotation_no,
    "Branch": q.branch_name || `Branch ${q.branch_id}`,
    "Student": q.student_name,
    "Created At": formatDate(q.created_at),
    "Discount": q.discount,
    "VAT": q.vat,
    "Total Amount": q.total_amount,
    "Remark": q.remark || "",
    "Bank 1": q.bank1_name || "",
    "Bank 2": q.bank2_name || "",
    "Item Description": (q.items || []).map((i) => i.description).join(", "),
    "Item Qty": (q.items || []).map((i) => i.quantity).join(", "),
    "Item Unit Price": (q.items || []).map((i) => i.unit_price).join(", "),
    "Item Amount": (q.items || []).map((i) => i.amount).join(", "),
  }))}
  filename={`quotations_${moment().format("YYYYMMDD_HHmm")}.csv`}
  target="_blank"
  className="ant-btn ant-btn-default"
  style={{
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    padding: '5px 10px',
    borderRadius: '8px',
    textDecoration: 'none'
  }}
>
  <DownloadOutlined style={{ marginRight: '8px' }} />
  Export CSV
</CSVLink>
        </Space>
      </div>

      <Row gutter={16} style={{ marginBottom: 24 }}>
  <Col span={20}>
    <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
      {/* Branch Filter (Superadmin only) */}
      {userRole === "superadmin" && (
        <div>
          <Select
            showSearch
            placeholder="Filter by branch"
            value={selectedBranch || undefined}
            onChange={(value) => {
              setSelectedBranch(value || null);
              fetchQuotations(value || null);
            }}
            style={{ width: 200 }}
            allowClear
            optionFilterProp="children"
          >
            <Option value="">All Branches</Option>
            {branches.map((branch) => (
              <Option key={branch.id} value={branch.id}>
                {branch.name}
              </Option>
            ))}
          </Select>
        </div>
      )}

      {/* Date Range Filter */}
      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <Text strong style={{ whiteSpace: 'nowrap' }}>
          <FilterOutlined /> Date Range
        </Text>
        
        {/* Start Date */}
        <div>
          <input
            type="date"
            id="range-start-date"
            value={dateRange?.[0] ? dateRange[0].format('YYYY-MM-DD') : ''}
            onChange={(e) => {
              const startDate = e.target.value ? dayjs(e.target.value, 'YYYY-MM-DD') : null;
              const endDate = dateRange?.[1] || null;
              handleDateRangeChange([startDate, endDate]);
            }}
            style={{ display: 'none' }}
          />
          <input
            type="text"
            readOnly
            value={dateRange?.[0] ? dateRange[0].format('DD MMM YYYY') : ''}
            placeholder="Start Date"
            onClick={() => document.getElementById('range-start-date')?.showPicker()}
            style={{
              padding: '4px 8px',
              borderRadius: 4,
              border: '1px solid #d9d9d9',
              cursor: 'pointer',
              width: '120px',
              textAlign: 'center',
            }}
          />
        </div>

        <Text type="secondary">to</Text>

        {/* End Date */}
        <div>
          <input
            type="date"
            id="range-end-date"
            value={dateRange?.[1] ? dateRange[1].format('YYYY-MM-DD') : ''}
            min={dateRange?.[0] ? dateRange[0].format('YYYY-MM-DD') : undefined}
            onChange={(e) => {
              const startDate = dateRange?.[0] || null;
              const endDate = e.target.value ? dayjs(e.target.value, 'YYYY-MM-DD') : null;
              handleDateRangeChange([startDate, endDate]);
            }}
            style={{ display: 'none' }}
          />
          <input
            type="text"
            readOnly
            value={dateRange?.[1] ? dateRange[1].format('DD MMM YYYY') : ''}
            placeholder="End Date"
            onClick={() => document.getElementById('range-end-date')?.showPicker()}
            style={{
              padding: '4px 8px',
              borderRadius: 4,
              border: '1px solid #d9d9d9',
              cursor: 'pointer',
              width: '120px',
              textAlign: 'center',
            }}
          />
        </div>
      </div>

      {/* Search Input */}
      <div style={{ flex: 1, minWidth: '300px' }}>
        <Input 
          placeholder="Search by student name, or quotation no."
          value={searchTerm}
          onChange={handleSearchChange}
          prefix={<SearchOutlined />}
        />
      </div>
    </div>
  </Col>
  
  <Col span={4}>
    <Button type="primary" onClick={fetchQuotations}>
      Filter
    </Button>
  </Col>
</Row>

      <Table
        columns={quotationColumns}
        dataSource={quotations}
        rowKey="id"
        loading={isLoading}
        pagination={{ pageSize: 10 }}
        scroll={{ x: 'max-content' }}
        style={{ width: '100%' }}
      />

      {/* Create/Edit Quotation Drawer */}
      <Drawer
        title={editingQuotation ? "Edit Quotation" : "Create New Quotation"}
        width={1200}
        onClose={() => {
          setQuotationDrawerVisible(false);
          resetForm();
        }}
        open={quotationDrawerVisible}
        extra={
          <Space>
            <Button onClick={() => setQuotationDrawerVisible(false)}>
              Cancel
            </Button>
            {activeTab === 'quotation' && (
              <Button type="primary" onClick={handleSubmitQuotation}>
                {editingQuotation ? "Update" : "Create"} Quotation
              </Button>
            )}
          </Space>
        }
      >
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="Quotation Details" key="quotation" >
            <Form form={form} layout="vertical" disabled={userRole === "superadmin"}>
              {/* Branch Section */}
                  <Card title="Branch Information" style={{ marginBottom: "24px" }}>
                          <Row gutter={16}>
                            <Col span={12}>
                              <Form.Item name="branch_id" hidden>
                                <Input type="hidden" />
                              </Form.Item>

                              <Form.Item label="Branch">
                                <Input
                                  value={
                                    branches.find((b) => String(b.id) === String(userBranchId))?.name ||
                                    "Unknown Branch"
                                  }
                                  disabled
                                />
                              </Form.Item>

                            </Col>
                          </Row>
                        </Card>
              {/* Student Section */}
              <Card title="Student Information" style={{ marginBottom: '24px' }}>
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item label="Student Type">
                      <Select
                        value={studentType}
                        onChange={setStudentType}
                        style={{ width: '200px' }}
                      >
                        <Option value="existing">Existing Student</Option>
                        <Option value="temp">Temporary Student</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                {studentType === 'existing' ? (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="studentId"
                        label="Select Student"
                        rules={[{ required: true, message: 'Please select a student' }]}
                      >
                        <Select
                          showSearch
                          placeholder="Search and select student"
                          onSearch={fetchStudents}
                          onChange={handleStudentSelect}
                          filterOption={false}
                        >
                         {students.map((student, index) => (
                            <Option
                                key={student.value ?? `student-${index}`}
                                value={student.value}
                            >
                                {student.label}
                            </Option>
                            ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ) : (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="tempStudentId"
                        label="Select Temp Student"
                        rules={[{ required: true, message: 'Please select a temp student' }]}
                      >
                        <Select
                          showSearch
                          placeholder="Select temporary student"
                          onChange={handleTempStudentSelect}
                          dropdownRender={menu => (
                            <div>
                              {menu}
                              <Divider style={{ margin: '4px 0' }} />
                              <div
                                style={{ padding: '8px', cursor: 'pointer' }}
                                onClick={() => setActiveTab('tempStudents')}
                              >
                                <PlusOutlined /> Manage temp students
                              </div>
                            </div>
                          )}
                        >
                          {tempStudents.map(student => (
                            <Option key={student.id} value={student.id}>
                              {student.firstname} {student.lastname} - {student.phone}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                )}

                {/* Display selected student details */}
                {studentDetails.firstname && (
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item name="firstname" label="First Name">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="lastname" label="Last Name">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="phone" label="Phone">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item name="address" label="address">
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </Row>
                )}
              </Card>

              <Card title="Payment Information" style={{ marginBottom: '24px' }}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      name="bankDetailsId1"
                      label="Select Bank Details (Primary)"
                      rules={[{ required: true, message: 'Please select bank details' }]}
                    >
                      <Select
                        placeholder="Select primary bank details"
                        onChange={(id) => handleBankDetailsSelect(id, 1)}
                        dropdownRender={menu => (
                          <div>
                            {menu}
                            <Divider style={{ margin: '4px 0' }} />
                            <div
                              style={{ padding: '8px', cursor: 'pointer' }}
                              onClick={() => setActiveTab('bankDetails')}
                            >
                              <PlusOutlined /> Manage bank details
                            </div>
                          </div>
                        )}
                      >
                        {bankDetails.map(bank => (
                          <Option key={bank.id} value={bank.id}>
                            {bank.bank_name} - {bank.account_name} (*{bank.account_number.slice(-4)})
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col span={12}>
                    <Form.Item
                      name="bankDetailsId2"
                      label="Select Bank Details (Secondary)"
                    >
                      <Select
                        placeholder="Optional second bank"
                        allowClear
                        onChange={(id) => handleBankDetailsSelect(id, 2)}
                      >
                        {bankDetails.map(bank => (
                          <Option key={bank.id} value={bank.id}>
                            {bank.bank_name} - {bank.account_name} (*{bank.account_number.slice(-4)})
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>

                {(selectedBankDetails[1] || selectedBankDetails[2]) && (
                  <Row gutter={16}>
                    {[1, 2].map(key => {
                      const bank = selectedBankDetails[key];
                      return bank ? (
                        <Col span={12} key={key}>
                          <Card size="small" title={`Bank Detail ${key}`}>
                            <p><strong>Bank:</strong> {bank.bank_name}</p>
                            <p><strong>Branch:</strong> {bank.bank_branch || '-'}</p>
                            <p><strong>Account:</strong> {bank.account_name}</p>
                            <p><strong>Number:</strong> {bank.account_number}</p>
                          </Card>
                        </Col>
                      ) : null;
                    })}
                  </Row>
                )}
              </Card>

              {/* Items Section */}
              <Card title="Quotation Items" style={{ marginBottom: '24px' }}>
                <Space style={{ marginBottom: '16px' }}>
                 <Button
                    type="dashed"
                    icon={<PlusOutlined />}
                    onClick={addQuotationItem}
                    disabled={quotationItems.length >= 5}
                    >
                    Add Custom Item
                    </Button>
                  <Select
                    placeholder="Add from existing class"
                    style={{ width: 300 }}
                    onChange={(classId) => {
                      const selectedClass = classes.find(c => c.groupid === classId);
                      if (selectedClass) {
                        addClassItem(selectedClass);
                      }
                    }}
                    value={null}
                  >
                    {classes.map(cls => (
                      <Option key={cls.groupid} value={cls.groupid}>
                        {cls.class_code} - {cls.title} - ฿{formatNumber(cls.price)}
                      </Option>
                    ))}
                  </Select>
                </Space>

                <Table
                  columns={itemColumns}
                  dataSource={quotationItems}
                  rowKey="id"
                  pagination={false}
                  size="small"
                />

                <Divider />

                {/* Totals Section */}
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label="Discount Amount (฿)">
                      <InputNumber
                        value={promotion}
                        onChange={setPromotion}
                        min={0}
                        precision={2}
                        style={{ width: '100%' }}
                        formatter={value => `฿ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/฿\s?|(,*)/g, '')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="VAT">
                      <Checkbox checked={vat} onChange={(e) => setVat(e.target.checked)}>
                        Include VAT 7%
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                

                <div style={{ textAlign: 'right', marginTop: '16px' }}>
                  <Space direction="vertical" style={{ width: '300px' }}>
                    <Row justify="space-between">
                      <Text>Subtotal:</Text>
                      <Text strong>฿{formatNumber(calculateSubtotal())}</Text>
                    </Row>
                    <Row justify="space-between">
                      <Text>Discount:</Text>
                      <Text>฿{formatNumber(promotion)}</Text>
                    </Row>
                    <Row justify="space-between">
                      <Text>VAT (7%):</Text>
                      <Text>฿{formatNumber(vat ? (calculateSubtotal() - promotion) * 0.07 : 0)}</Text>
                    </Row>
                    <Divider style={{ margin: '8px 0' }} />
                    <Row justify="space-between">
                      <Text strong>Total:</Text>
                      <Text strong style={{ fontSize: '18px' }}>฿{formatNumber(calculateTotal())}</Text>
                    </Row>
                  </Space>
                  <Form.Item name="remark" label="Remark">
                    <Input.TextArea placeholder="Enter any additional notes..." rows={3} />
                  </Form.Item>
                </div>
              </Card>
            </Form>
          </TabPane>

          <TabPane tab={<span><UserOutlined /> Temp Students</span>} key="tempStudents">
            <Card title="Temporary Students Management">
              <div style={{ marginBottom: '16px' }}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setEditingTempStudent(null);
                    tempStudentForm.resetFields();
                    setTempStudentModalVisible(true);
                  }}
                >
                  Add New Temp Student
                </Button>
              </div>

              <Table
                columns={tempStudentColumns}
                dataSource={tempStudents}
                rowKey="id"
                loading={isLoading}
                pagination={{ pageSize: 10 }}
                size="small"
              />
            </Card>
          </TabPane>
          <TabPane tab={<span><BankOutlined /> Bank Details</span>} key="bankDetails">
            <Card title="Bank Details Management">
              <div style={{ marginBottom: '16px' }}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => {
                    setEditingBankDetails(null);
                    bankDetailsForm.resetFields();
                    setBankDetailsModalVisible(true);
                  }}
                >
                  Add New Bank Details
                </Button>
              </div>

              <Table
                columns={bankDetailsColumns}
                dataSource={bankDetails}
                rowKey="id"
                loading={isLoading}
                pagination={{ pageSize: 10 }}
                size="small"
              />
            </Card>
          </TabPane>
        </Tabs>
      </Drawer>

      {/* Add/Edit Temp Student Modal */}
      <Modal
        title={editingTempStudent ? "Edit Temporary Student" : "Add Temporary Student"}
        open={tempStudentModalVisible}
        onCancel={() => {
          setTempStudentModalVisible(false);
          tempStudentForm.resetFields();
          setEditingTempStudent(null);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={tempStudentForm}
          layout="vertical"
          onFinish={handleCreateTempStudent}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="firstname"
                label="First Name"
                rules={[{ required: true, message: 'Please enter first name' }]}
              >
                <Input placeholder="Enter first name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="lastname"
                label="Last Name"
                rules={[{ required: true, message: 'Please enter last name' }]}
              >
                <Input placeholder="Enter last name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="nickname" label="Nickname">
                <Input placeholder="Enter nickname" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="phone" label="Phone">
                <Input placeholder="Enter phone number" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item name="address" label="Address">
                <TextArea placeholder="Enter address" rows={3} />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Space>
              <Button onClick={() => {
                setTempStudentModalVisible(false);
                tempStudentForm.resetFields();
                setEditingTempStudent(null);
              }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                {editingTempStudent ? "Update" : "Create"} Temp Student
              </Button>
            </Space>
          </Row>
        </Form>
      </Modal>

      {/* Add/Edit Bank Details Modal */}
      <Modal
        title={editingBankDetails ? "Edit Bank Details" : "Add Bank Details"}
        open={bankDetailsModalVisible}
        onCancel={() => {
          setBankDetailsModalVisible(false);
          bankDetailsForm.resetFields();
          setEditingBankDetails(null);
        }}
        footer={null}
        width={600}
      >
        <Form
          form={bankDetailsForm}
          layout="vertical"
          onFinish={handleCreateBankDetails}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="branch_id"
                label="Branch"
                rules={[{ required: true, message: "Please select a branch" }]}
              >
                {userRole === "admin" ? (
                  // Admin: fixed branch (disabled input)
                  <Input
                    value={branches.find(b => b.id === userBranchId)?.name || "Unknown Branch"}
                    disabled
                  />
                ) : (
                  // Superadmin: dropdown to select branch
                    <Select
                      placeholder="Select Branch"
                      value={selectedBranch}
                      onChange={(value) => {
                        setSelectedBranch(value);
                        form.setFieldsValue({ branch_id: value });

                        fetchStudents("", value);
                        fetchTempStudents(value);
                        fetchClasses(value);
                        fetchQuotations(value);
                      }}
                    >
                      {branches.map(branch => (
                        <Option key={branch.id} value={branch.id}>
                          {branch.name}
                        </Option>
                      ))}
                    </Select>

                )}
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="bank_name"
                label="Bank Name"
                rules={[{ required: true, message: 'Please enter bank name' }]}
              >
                <Input placeholder="Enter bank name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="bank_branch" label="Bank Branch">
                <Input placeholder="Enter bank branch" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="account_name"
                label="Account Name"
                rules={[{ required: true, message: 'Please enter account name' }]}
              >
                <Input placeholder="Enter account name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="account_number"
                label="Account Number"
                rules={[{ required: true, message: 'Please enter account number' }]}
              >
                <Input placeholder="Enter account number" />
              </Form.Item>
            </Col>
          </Row>
          <Row justify="end">
            <Space>
              <Button onClick={() => {
                setBankDetailsModalVisible(false);
                bankDetailsForm.resetFields();
                setEditingBankDetails(null);
              }}>
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                {editingBankDetails ? "Update" : "Create"} Bank Details
              </Button>
            </Space>
          </Row>
        </Form>
      </Modal>

        <Modal
        open={previewVisible}
        onCancel={() => setPreviewVisible(false)}
        footer={null} 
        width={1200}
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff000', padding: '10px', borderRadius: '8px' }}>
            <span>Quotation Preview</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                <Row justify="space-between">
                    <Text strong>Change Date:</Text>
                    <input
                        type="date"
                        style={{ border: '1px solid #ccc', borderRadius: 4 }}
                        value={customCreatedAt ? moment(customCreatedAt).format('YYYY-MM-DD') : ''}
                        onChange={(e) => setCustomCreatedAt(e.target.value ? new Date(e.target.value) : null)}
                    />
                    </Row>
              <span style={{ fontSize: '14px', fontWeight: 'normal' }}>Valid for:</span>
              
              <Select
                value={previewExpirationDays}
                onChange={(value) => {
                  setPreviewExpirationDays(value);
                  setPreviewData(prev => ({
                    ...prev,
                    expiration_days: value
                  }));
                }}
                style={{ width: 150 }}
                size="small"
              >
                <Option value={1}>1 Day</Option>
                <Option value={2}>2 Days</Option>
                <Option value={3}>3 Days</Option>
                <Option value={7}>1 Week</Option>
                <Option value={15}>15 Days</Option>
                <Option value={30}>1 Month</Option>
                <Option value={60}>2 Months</Option>
                <Option value={90}>3 Months</Option>
              </Select>
            </div>
          </div>
        }
      >
        <QuotationPreview data={previewData} overrideCreatedAt={customCreatedAt} />
      </Modal>
    </div>
  );
};

export default withRoleAccess(CreateQuotation, ['superadmin', 'admin']);